import { render, staticRenderFns } from "./mercadopagostatus.vue?vue&type=template&id=62847508&lang=html&"
import script from "./mercadopagostatus.vue?vue&type=script&lang=js&"
export * from "./mercadopagostatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports